import { FirebaseAuthProvider } from "react-admin-firebase";
import {initializeApp } from "firebase/app";

const firebaseConfig = {
	apiKey: "AIzaSyDL5E6ys0sldJw-4jSmvd9k_3it87KBqCU",
	authDomain: "omf-crowdfunding-493207.firebaseapp.com",
	projectId: "omf-crowdfunding-493207",
	storageBucket: "omf-crowdfunding-493207.firebasestorage.app",
	messagingSenderId: "582255718880",
	appId: "1:582255718880:web:11a0c52fe7da668698bb85",
};

export const firebaseApp = initializeApp(firebaseConfig);

const firebaseOptions = {
	logging: process.env.NODE_ENV === "development",
	app: firebaseApp,
};

const firebaseAuthProvider = FirebaseAuthProvider(firebaseConfig, firebaseOptions);

export default firebaseAuthProvider;
